var map = {
	"./board_01.svg": "7238",
	"./buttons/pauseBtn.svg": "6ad8",
	"./buttons/playBtn.svg": "2381",
	"./css/bg_pattern-35.png": "6df4",
	"./css/bg_pattern-60.png": "ad6d",
	"./css/bg_pattern.png": "516e",
	"./css/colors.scss": "90ab",
	"./css/styles_large.scss": "c8d5",
	"./css/styles_small.scss": "1233",
	"./css/vuetify_patch.scss": "5a81",
	"./data/cv": "1b10",
	"./data/cv.json": "1b10",
	"./data/import_to_mongo": "14a8",
	"./data/import_to_mongo.json": "14a8",
	"./img-board.svg": "9b4a",
	"./img-chip-board.svg": "9a08",
	"./img-display.svg": "5374",
	"./img-point-experiment-board.svg": "fa79",
	"./img-radiator-board.svg": "5ec0",
	"./iomico-map-pin.png": "9ced",
	"./iomico-map-pin.svg": "0db7",
	"./iomico_logo_1.svg": "af82",
	"./iomico_logo_2.svg": "b597",
	"./iomico_logo_text.svg": "1bab",
	"./logo.png": "cf05",
	"./menu-icon-cross.svg": "4c12",
	"./menu-icon-lines.svg": "3fa9",
	"./messengers/ico-facebook-messenger.svg": "ffe6",
	"./messengers/ico-skype.svg": "2095",
	"./messengers/ico-telegram.svg": "45f8",
	"./messengers/ico-viber.svg": "b709",
	"./messengers/ico-wechat.svg": "f3d0",
	"./messengers/ico-whatsapp.svg": "6ef4",
	"./portfolio/bead.jpg": "09b0",
	"./portfolio/bead__logo.svg": "99ee",
	"./portfolio/beaver.png": "332c",
	"./portfolio/beaver.svg": "af8c",
	"./portfolio/beaver__logo.png": "fceb",
	"./portfolio/byte.png": "f59a",
	"./portfolio/byte.svg": "dc3f",
	"./portfolio/byte__logo.png": "900b",
	"./portfolio/fixpel.png": "4f34",
	"./portfolio/fixpel__logo.png": "0b4d",
	"./portfolio/hatch.png": "16ba",
	"./portfolio/hatch__logo.png": "bf13",
	"./portfolio/iometeca.png": "8480",
	"./portfolio/iometeca__logo.svg": "c34e",
	"./portfolio/iomico__logo.svg": "e393",
	"./portfolio/keymaker.png": "430d",
	"./portfolio/keymaker__logo.svg": "1f99",
	"./portfolio/rfid-barcode-reader.jpg": "2a8f",
	"./portfolio/storekeeper.png": "175b",
	"./portfolio/storekeeper__logo.svg": "fea3",
	"./portfolio/tdk-realsense.jpg": "3f4e",
	"./portfolio/tdk__logo.svg": "2257",
	"./portfolio/tractive.png": "c2ab",
	"./portfolio/tractive__logo.png": "f3b4",
	"./portfolio/water-bottle.jpg": "81b5",
	"./services/service_electronics.png": "e32a",
	"./services/service_productdesign.png": "5e62",
	"./services/service_programming.png": "5e50",
	"./socials/ico-facebook.svg": "8d58",
	"./socials/ico-instagram.svg": "822e",
	"./socials/ico-linkedin-circle.svg": "6804",
	"./socials/ico-linkedin.svg": "e469",
	"./socials/ico-twitter.svg": "7e53",
	"./socials/ico-youtube-circle.svg": "8cb2",
	"./socials/ico-youtube.svg": "61b4",
	"./tag-about.svg": "1572",
	"./tag-address.svg": "084e",
	"./tag-belarus.svg": "2076",
	"./tag-electronics.svg": "80b6",
	"./tag-email.svg": "b602",
	"./tag-expertise.svg": "7c02",
	"./tag-industrial-design.svg": "6fd3",
	"./tag-management.svg": "da3c",
	"./tag-pcb-firmware.svg": "1154",
	"./tag-phone.svg": "2f67",
	"./tag-programming.svg": "f538",
	"./tag-team.svg": "a585",
	"./tag-usa.svg": "22b1",
	"./team": "1585",
	"./team.json": "1585",
	"./team_pictures/aliaksandr.s__600x600.jpg": "f2c3",
	"./team_pictures/anatoli.a__600x600.jpg": "8ebd",
	"./team_pictures/anrei.l__600x600.jpg": "07e5",
	"./team_pictures/darya.s__600x600.jpg": "9adc",
	"./team_pictures/dmitry.b__600x600.jpg": "5a63",
	"./team_pictures/dzmitry.b__600x600.jpg": "234f",
	"./team_pictures/ernest.m__600x600.jpg": "d746",
	"./team_pictures/ihar.b__600x600.jpg": "c414",
	"./team_pictures/ihar.s__600x600.jpg": "c112",
	"./team_pictures/ilya.t__600x600.jpg": "e66d",
	"./team_pictures/jaime.c__600x600.jpg": "3d12",
	"./team_pictures/katsia.m__600x600.jpg": "e120",
	"./team_pictures/maksim.v__600x600.jpg": "e1dd",
	"./team_pictures/michael.b__600x600.jpg": "1e9d",
	"./team_pictures/mihail.r__600x600.jpg": "9773",
	"./team_pictures/mikalaj.m__600x600.jpg": "0d74",
	"./team_pictures/oleg.r__600x600.jpg": "d284",
	"./team_pictures/pavel.t__600x600.jpg": "23dd",
	"./team_pictures/pavel.z__600x600.jpg": "8e8b",
	"./team_pictures/vadzim.p__600x600.jpg": "95d5",
	"./team_pictures/vadzim.s__600x600.jpg": "37e7",
	"./team_pictures/vitali.c__600x600.jpg": "94e7",
	"./team_pictures/vladislav.p__600x600.jpg": "6620",
	"./video/intro_200x200.mp4": "5217",
	"./video/intro_250x250.mp4": "79e9",
	"./video/intro_300x300 (updated).mp4": "a212",
	"./video/intro_300x300.mp4": "b17b",
	"./video/intro_300x300_cover.jpg": "1569",
	"./video/intro_600x600.mp4": "a729"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";